// Importing components
import { FormElems } from 'components';

// Importing constant
import { POPUP_ENUM } from '../../utils/constants/commonValues';
import { DEADLINE_OPTIONS } from './constant';

// Importing Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import './extendChargeBackDeadlineForm.scss';

const ExtendChargeBackDeadlineForm = ({ handleSubmit, onClose, onSubmit }) => {
    const handleChargeBackExtensionSubmit = values => {
        onSubmit(POPUP_ENUM.EXTEND_DEADLINE_FORM, values);
    };

    return (
        <form
            className="extend-chargeback-deadline-form"
            onSubmit={handleSubmit(handleChargeBackExtensionSubmit)}
        >
            <div className="form-field ">
                <Field
                    name="deadline"
                    component={FormElems.Radio}
                    labelField="name"
                    valueField="value"
                    wrapperClass="wrap-checkbox"
                    defaultSelected={'1'}
                    options={DEADLINE_OPTIONS}
                />
            </div>
            <div className="form-section-actions">
                <FormElems.Button
                    buttonType="secondary"
                    id="back-btn"
                    text="Cancel"
                    type="button"
                    handleClick={onClose}
                    customClass="back-btn"
                />
                <FormElems.Button
                    id="next-btn"
                    buttonType="primary"
                    text="Submit"
                />
            </div>
        </form>
    );
};

const mapStateToProps = ({ form }) => ({
    formData: form['extend-chargeback-deadline-form'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});

export default compose(
    reduxForm({
        form: 'extend-chargeback-deadline-form',
        enableReinitialize: true,
        validate: () => {},
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(ExtendChargeBackDeadlineForm);

// PropType validation for UpdateChargeBackStatusForm component
ExtendChargeBackDeadlineForm.propTypes = {
    formData: PropTypes.object,
    onClose: PropTypes.func,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
};
